module.exports = __webpack_public_path__ + "media/src/images/icon__multiselectRevealCorrect--dark-f5eff8647d887cdcb3afd66e87b7bffc.png";